/* Barra de progreso de regalos. Funciona con varias barras en la misma página.
   El markup lo pone snippets/barra-regalos.liquid (.hxg con sus .hxg__tier[data-goal]). */
(() => {
  if (window.__hxgRender) return window.__hxgRender();

  let pedido = null;
  let pedidoEn = 0;

  function carrito() {
    const ahora = Date.now();
    if (!pedido || ahora - pedidoEn > 1000) {
      pedidoEn = ahora;
      pedido = fetch('/cart.js').then(r => r.json()).catch(() => null);
    }
    return pedido;
  }

  /*--pct--*/
  function pct(sub, goals) {
    const n = goals.length;
    if (!n) return 0;
    const centers = goals.map((_, i) => ((i + 0.5) / n) * 100);
    const i = goals.findIndex(g => sub < g);
    if (i === -1) return 100;
    const prevGoal = i ? goals[i - 1] : 0;
    const prevC = i ? centers[i - 1] : 0;
    const span = goals[i] - prevGoal || 1;
    return prevC + ((sub - prevGoal) / span) * (centers[i] - prevC);
  }
  /*--/pct--*/

  async function render() {
    const barras = document.querySelectorAll('.hxg');
    if (!barras.length) return;
    const cart = await carrito();
    if (!cart) return;
    const sub = cart.items_subtotal_price;

    barras.forEach(root => {
      const tiers = [...root.querySelectorAll('.hxg__tier')]
        .map(el => ({ el, goal: Number(el.dataset.goal) * 100, name: el.querySelector('.hxg__name').textContent.trim() }))
        .sort((a, b) => a.goal - b.goal);
      if (!tiers.length) return;

      const fmt = n => new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: root.dataset.currency || 'MXN',
        maximumFractionDigits: 0
      }).format(n / 100);

      tiers.forEach(t => t.el.toggleAttribute('data-on', sub >= t.goal));
      root.querySelector('.hxg__fill').style.width = pct(sub, tiers.map(t => t.goal)) + '%';

      const next = tiers.find(t => sub < t.goal);
      root.querySelector('.hxg__msg').textContent = next
        ? `Te faltan ${fmt(next.goal - sub)} para llevarte GRATIS ${next.name}`
        : '🎉 ¡Desbloqueaste todos los regalos!';
    });
  }

  window.__hxgRender = render;

  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const p = origFetch.apply(this, args);
    const url = String(args[0] && args[0].url || args[0] || '');
    if (url.includes('/cart/')) p.then(() => { pedidoEn = 0; render(); });
    return p;
  };

  ['cart:change', 'cart:refresh', 'cart:updated', 'shopify:section:load'].forEach(e =>
    document.addEventListener(e, () => { pedidoEn = 0; render(); })
  );

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  render();
})();
